import { render, staticRenderFns } from "./VScrollable.vue?vue&type=template&id=01e37aaf&lang=pug"
import script from "./VScrollable.vue?vue&type=script&lang=js"
export * from "./VScrollable.vue?vue&type=script&lang=js"
import style0 from "./VScrollable.vue?vue&type=style&index=0&id=01e37aaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports